import React from "react";
import { Button, Card, Form, Input, Typography } from "antd";

import logo from "@assets/logo-name.svg";
import BackGroundAnimation from "../../components/BackGroundAnimation";
import * as S from "./style";
import { useResetPassword } from "./useResetPassword";

function ResetPassword() {
  const {
    isRecoverStep,
    isSubmitting,
    title,
    description,
    onSubmitEmail,
    onSubmitRecover,
    goToLogin,
    onBackFromRecoverStep,
    onResendMail,
    hasEmail,
  } = useResetPassword();

  return (
    <S.Container>
      <BackGroundAnimation />
      <S.Part>
        <S.ContainerCard>
          <Card
            hoverable
            style={{ borderRadius: "10px" }}
            cover={
              <S.HeaderCard>
                <img src={logo} alt="logo" />
              </S.HeaderCard>
            }
          >
            <div style={{ textAlign: "center", marginBottom: 16 }}>
              <Typography.Title level={4} style={{ marginBottom: 8 }}>
                {title}
              </Typography.Title>
              <Typography.Text type="secondary">{description}</Typography.Text>
            </div>

            {!isRecoverStep ? (
              <Form layout="vertical" onFinish={onSubmitEmail}>
                <Form.Item
                  label="E-mail"
                  name="email"
                  rules={[
                    { required: true, message: "Informe seu e-mail" },
                    { type: "email", message: "Informe um e-mail válido" },
                  ]}
                >
                  <Input placeholder="seuemail@dominio.com" />
                </Form.Item>

                <div style={{ display: "flex", gap: 12, justifyContent: "end" }}>
                  <Button onClick={goToLogin}>Voltar</Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isSubmitting}
                  >
                    Enviar
                  </Button>
                </div>
              </Form>
            ) : (
              <Form layout="vertical" onFinish={onSubmitRecover}>
                <Form.Item
                  label="Código de confirmação"
                  name="confirmationCode"
                  rules={[
                    { required: true, message: "Informe o código" },
                    { whitespace: true, message: "Informe o código" },
                  ]}
                >
                  <Input placeholder="Ex.: 123456" />
                </Form.Item>

                <Form.Item
                  label="Nova senha"
                  name="password"
                  rules={[{ required: true, message: "Informe a nova senha" }]}
                >
                  <Input.Password placeholder="Nova senha" />
                </Form.Item>

                <Form.Item
                  label="Repita a nova senha"
                  name="confirmPassword"
                  dependencies={["password"]}
                  rules={[
                    { required: true, message: "Confirme a nova senha" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const password = getFieldValue("password");
                        if (!value || value === password)
                          return Promise.resolve();
                        return Promise.reject(
                          new Error("As senhas não conferem")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Confirmar nova senha" />
                </Form.Item>

                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <Button onClick={onBackFromRecoverStep}>Voltar</Button>

                  <div style={{ display: "flex", gap: 12 }}>
                    <Button
                      onClick={onResendMail}
                      disabled={!hasEmail}
                    >
                      Reenviar e-mail
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={isSubmitting}
                    >
                      Prosseguir
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Card>
        </S.ContainerCard>
      </S.Part>
    </S.Container>
  );
}

export default ResetPassword;
